import { z } from "zod";

import { ExpirationPeriod } from "@classview/shared-types";

const shareRecordingSchema = z.object({
  expirationPeriod: z.nativeEnum(ExpirationPeriod),
});
type ShareRecordingFormData = z.infer<typeof shareRecordingSchema>;

export { shareRecordingSchema };
export type { ShareRecordingFormData };
